var _effectorFileName = "/builds/gmini/front-common/src/helpers/versionDateCommon.ts";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-iso-string.js";
import moment from 'moment';
export function decorateTime(_ref) {
  var h = _ref.h,
      m = _ref.m;
  var hours = '';
  var minutes = '';

  if (h < 10) {
    hours = "0".concat(h);
  }

  if (m < 10) {
    minutes = "0".concat(m);
  }

  return {
    hours: hours || h,
    minutes: minutes || m
  };
}
export function sortByDate(a, b) {
  return new Date(b).getTime() - new Date(a).getTime();
}
export function isNotNullableTime(date) {
  return !!new Date(date).getTime();
}
export function getTimeFromDate(date) {
  var dateTime = new Date(date);

  if (dateTime.getTime() === 0) {
    return '';
  }

  var _decorateTime = decorateTime({
    h: dateTime.getHours(),
    m: dateTime.getMinutes()
  }),
      hours = _decorateTime.hours,
      minutes = _decorateTime.minutes;

  return "".concat(hours, ":").concat(minutes);
}
export function isActualDate(date) {
  return moment(date).format('DDMMYY') === moment().format('DDMMYY');
}
export function getCustomDate(date) {
  var dateTime = new Date(date);
  return "".concat(dateTime.toLocaleString('default', {
    month: 'long',
    day: 'numeric'
  }), ' ').concat(dateTime.getFullYear());
}
export function getDate(date) {
  return "".concat(new Date(date).toLocaleString('default', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric'
  }));
}
export function fromDateTimeToDate(dateTime) {
  return new Date(dateTime).toISOString().substring(0, 10);
}
export function compareDates(dateTimeA, dateTimeB) {
  return fromDateTimeToDate(dateTimeA) === fromDateTimeToDate(dateTimeB);
}
export var getVersionDateLabel = function getVersionDateLabel(date, isActualVersion) {
  var actualDate = isActualDate(date);
  var fullDate = isNotNullableTime(date) ? "\u043E\u0442  ".concat(getTimeFromDate(date), ", ").concat(getDate(date)) : '';
  var onlyTime = isNotNullableTime(date) ? "\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043E \u0432 ".concat(getTimeFromDate(date)) : '';
  return isActualVersion ? actualDate ? onlyTime : fullDate : fullDate;
};